<!-- 单品特价 -->
<template>
    <div class="page_content">
        <!-- <subComponents ref="showSelectData"></subComponents> -->

        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <!-- 促销赠送 -->
            <yhqGiftsAction v-if="showStatus" ref="yhqGiftsAction" @drawerCancel="drawerCancel" @toDetail="toDetail"
                :actionData="actionData"></yhqGiftsAction>
        </el-drawer>
        
       
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false" @getPageInfo="getPageInfo"
                @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search :searchList="searchList" :getRequestData="getRequestData" @searchData="searchData"
                    @openSearch="openSearch"></v-search>
            </div>
        </div>
        <div style="display: flex; just-content: space-between">
            <div class="page_content_center" style="width: 100%">

                <el-table :key="tableFlag" stripe @row-click="storePriceClick" :data="returnData.list"
                    :height="tableHeight" border style="width: 100%" highlight-current-row size="mini">
                    <!-- 主信息 -->

                    <el-table-column header-align='center' label="选择操作" width="80">
                        <template slot-scope="scope">
                            <el-radio v-model="selectedRowIndex" :label="scope.$index" border size="mini"
                                @change="handleRadioChange(scope.row, scope.$index)">
                                <i class="el-icon-thumb"></i>
                            </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column v-for="(tableValye, tableKey) in pageShowData" :key="tableKey" align="center"
                        :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
                        :min-width="tableValye.fieldWeight" :fixed="tableValye.fixed || false">
                        <template slot-scope="scope">


                            <span v-if="tableValye.entityField == 'startDate'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.entityField == 'endDate'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.entityField == 'planType'">
                                {{ scope.row.planType == 1 ? '促销赠送' : scope.row.planType == 2 ? '促销调价' : '超量促销' }}
                            </span>
                            <span v-else-if="tableValye.entityField == 'dayStartTime'">
                                {{ formatTimeOnly(scope.row.dayStartTime) }}
                            </span>
                            <span v-else-if="tableValye.entityField == 'dayEndTime'">
                                {{ formatTimeOnly(scope.row.dayEndTime) }}
                            </span>

                            <span v-else-if="tableValye.entityField == 'round'">
                                {{ scope.row.round }}
                            </span>
                            <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                        </template>
                    </el-table-column>
                </el-table>

            </div>

        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <!-- 检索方案 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body="true" :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import { nameList, searchList } from "./couponList.js"
import yhqGiftsAction from '@/components/yhqGiftsAction.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        yhqGiftsAction,
    },
    data() {
        //这里存放数据
        return {
            sField: "",
            exTitle: "",
            exWidth: "",
            searchList: searchList,
            getRequestData: {
                
                businessId: "",
                creater: 0,
                ormId: 0,
                page: 1,
                rows: 30,
                start: "",
                end: "",            
                yhqName: "",
            },

            //---------------
            seTitle: "",
            DialogVisible: false,
            seId: "",
            setField: "",
            setType: "",
            seWidth: "0",
            parentSearchData: {},
            //---------------
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },

            buttonList: [],
            multipleSelection: [],
            pageShowData: {},
            pageShowPeopleData: {},
            tableFlag: 0,
            selectedDataIndex: 0,
            yhqIds: "",
            tableHeight: 0,
            showStatus: false,
         
            actionData: {},
            loading: false,
            selectedRowIndex: null,
            priceGroupForm: {
                bgmName: '',
                bgmId: '',
                price: '',

            },

        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.pspmBuycus = ""
                }
            },
            deep: true,
        },


    },
    //方法集合
    methods: {
        formatTimeOnly(val) {
            if (val == 0) {
                return "00:00:00"
            }
            if (!val) return '';
            
            // 直接将秒数转换为时分秒
            const totalSeconds = Number(val);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            
            // 补零
            const h = hours.toString().padStart(2, '0');
            const m = minutes.toString().padStart(2, '0');
            const s = seconds.toString().padStart(2, '0');
            
            return `${h}:${m}:${s}`;
        },
        // 子组件触发
        drawerCancel(e) {
            console.log(e, "+++++++++")
            this.showStatus = false

            if (e == 1) {
                this.getPageInfo()
            }

        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
            this.getPageInfo()
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)

            this.$refs["customDesign"].openBox(
                pathInfo.jurId,
                this.pageShowData,
                pathInfo.jurName
            )
        },
        storePriceClick(row) {
            this.yhqIds = row.yhqId
            this.selectedRowIndex = this.returnData.list.findIndex(item => item.yhqId === row.yhqId)
            this.multipleSelection = [] // 切换行时清空门店选择

        },

        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.seId = sId //检索方案Id
            this.sField = sField //赋值字段
            this.DialogVisible = true //判断是否打开弹框
            this.seType = type
        },
        //检索方案返回的数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false
                this.paramValue(val) //赋值字段，赋值
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",")
            arr.forEach((item) => {
                this.priceGroupForm[item] = val[item]
            })
        },
        //关闭提取、检索方案弹框关闭 创建键盘事件
        closeChild() {
            addEventListener("keyup", this.keyUp) //创建监听键盘事件
        },


        getSeWidth(e) {
            console.log(e)
            this.seWidth = e + "%"
        },
        getWidth(e) {
            console.log(e)
            this.exWidth = e + "%"
        },
        getSearchName(e) {
            console.log(e)
            this.seTitle = e
        },



        // 获取数据列表
        async getPageInfo() {
            this.pageShowData = JSON.parse(JSON.stringify(nameList))

            let res = await this.$http.getYhqList(this.getRequestData)
            if (res.status == 200) {
                this.returnData.list = res.result.list
                this.returnData.total = res.result.total
                this.returnData.pageNum = res.result.pageNum
                this.returnData.pages = res.result.pages
                this.selectedDataIndex = 0
                if (this.returnData.list.length > 0) {
                    this.yhqIds = this.returnData.list[0].yhqId

                    this.$nextTick(() => {
                        if (this.returnData.list.length > 0) {
                            this.selectedRowIndex = 0
                            this.multipleSelection = [this.returnData.list[0]]
                        }
                    })
                } else {
                    this.BindList = []
                }
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                })
            }

        },

        // 动作集合
        async actionSet(actionData) {
            console.log(actionData.actionType)
            switch (actionData.actionType) {
                case 0:

                    break
                case 1:
                    if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        })
                        return false
                    }
                    try {
                        // 获取商品详情内容
                        let responseData = await this.$http.getYhqDetail({
                            ids: [this.yhqIds]
                        })
                        console.log(responseData, 'responseData');
                        if (responseData.status == 200) {
                            this.returnData.list[this.selectedRowIndex] = responseData.result.planDetail
                            this.returnData.list[this.selectedRowIndex].storeList = responseData.result.planDetail.storeList
                            this.returnData.list[this.selectedRowIndex].mcTypeList = responseData.result.planDetail.mcTypeList
                            this.returnData.list[this.selectedRowIndex].conBgmList = responseData.result.planDetail.conBgmList
                            this.returnData.list[this.selectedRowIndex].giftBgmList = responseData.result.planDetail.giftBgmList
                            this.returnData.list[this.selectedRowIndex].remark = responseData.result.remark
                            this.returnData.list[this.selectedRowIndex].yhqName = responseData.result.yhqName
                            this.returnData.list[this.selectedRowIndex].yhqDesc = responseData.result.yhqDesc
                            this.returnData.list[this.selectedRowIndex].limitDay = responseData.result.limitDay
                            this.returnData.list[this.selectedRowIndex].yhqId = responseData.result.yhqId
                 
                            
                             
                            this.showStatus = true
                            this.actionData = {
                                cate: 1,
                                formData: [],
                                oldData: this.returnData.list[this.selectedRowIndex],
                            }
                        }
                    } catch (error) {
                        console.log(error, 'error');
                    }



                    break
                case 2:
                    this.delDataAction()
                    break
                case 3:
                    this.submitData()
                    break
                case 12:
                this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: [],
                        oldData: "",
                    }
                    break
            }
        },



        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },

        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },


        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },

        // 获取数据列表 优惠券
        async getDataList() {
            let responseData = await this.$http.getYhqList(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                this.returnData.pages = responseData.result.pages
                this.selectedDataIndex = 0


                if (this.returnData.list.length > 0) {

                    this.yhqIds = this.returnData.list[0].yhqId
                    this.$nextTick(() => {
                        if (this.returnData.list.length > 0) {
                            this.selectedRowIndex = 0
                            this.multipleSelection = [this.returnData.list[0]]
                        }
                    })
                }
                this.$nextTick(() => {
                    this.tableHeight = this.$common.getTableHeight()
                    this.tableFlag++
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
        },


        // 删除数据
        delDataAction() {
            if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                })
                return false
            }

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [this.returnData.list[this.selectedRowIndex].yhqId],
                    }
                    let responseData = await this.$http.deraYhqDelYhq(delData)
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })

                        this.getDataList()
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        })
                    }
                })
                .catch(() => { })
        },
        // 提交审核
        async submitData() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: "暂无数据",
                        type: "error",
                    });
                    return false;
                }
            }
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            this.$confirm("确定要提交审核吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        businessKey: dataInfo.yhqId,
                    };
                    let responseData = await this.$http.deraYhqSubmitAudit(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },


        handleRadioChange(row, index) {
            this.selectedRowIndex = index;
            this.yhqIds = row.id;

        },



    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
        this.getButtonList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight()
            this.tableFlag++
        })
    },
    updated() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight()
        })
    }, //生命周期 - 更新之后

}
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.btns {
    display: flex;
    position: absolute;
    z-index: 999;
    padding-left: 10px;
    padding-top: 2px;
}

::v-deep.xunjia tr {
    height: 39px !important;
}

::v-deep.xunjia .el-button {
    font-size: 12px;
    padding: 5px 10px;
}

::v-deep.xunjia .el-button--danger {
    color: #fff;
    background-color: #f56c6c;
    border-color: #f56c6c;
}

::v-deep.xunjia .el-button--danger:hover {
    color: #fff;
    background-color: #f78989;
    border-color: #f78989;
}

::v-deep.xunjia .el-table__fixed-right {
    height: 100% !important;
    position: absolute;
    top: 0;
    overflow: hidden;
    background-color: #fff;
    z-index: 3;
}

::v-deep.xunjia .el-table__fixed-right-patch {
    background-color: #fff;
}
</style>